import { useAdminAuth } from "context/context";
import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";

const Link = ({ children, type, role, ...rest }) => {
  const { roles } = useAdminAuth();

  const [isHovered, setIsHovered] = useState(false);

  const hoverStyle = {
    backgroundColor: "#ffe0b2", // Example hover effect
  };

  // custom css for link
  const linkCss1 = {
    color: "rgba(255, 118, 5, 0.94)",
  };

  return (
    <>
      {/* if type is non acl */}
      {type === "acl" &&
        (roles.includes(role) ? (
          <RouterLink {...rest} style={linkCss1}>
            {children}
          </RouterLink>
        ) : (
          <RouterLink to="" style={linkCss1} className="disabled-link">
            {children}
          </RouterLink>
        ))}

      {/* if type is acl */}
      {type !== "acl" && (
        <RouterLink
          {...rest}
          style={linkCss1}
          // style={{ ...linkCss1, ...(isHovered ? hoverStyle : {}) }}
          // onMouseEnter={() => setIsHovered(true)}
          // onMouseLeave={() => setIsHovered(false)}
        >
          {children}
        </RouterLink>
      )}
    </>
  );
};

export default Link;
